import React from "react";
import ProjectSection from "../components/ProjectSection";

const Projects = () => {
  return (
    <div>
      <ProjectSection isFullPage={true} />
    </div>
  );
};

export default Projects;
